// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UserService } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Service/User';
import { ERR_COL_TER_USER_SVC, SUC_COL_TER_USER_SVC } from '../../../../utils/strings';
import { useExerciseSubmission } from '../../ledger/useSubmission';

export const useTerminateUserService = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_Terminate,
    SUC_COL_TER_USER_SVC,
    ERR_COL_TER_USER_SVC,
  );
  return submit;
};
